import get from 'lodash.get';

const getPartnerBranding = (rootState) =>
  get(rootState, 'user.partnerData.properties.wsBranding', null);

export default getPartnerBranding;
